import { render, staticRenderFns } from "./MailInvoiceSettingCard.vue?vue&type=template&id=1c6ce07a&scoped=true&"
import script from "./MailInvoiceSettingCard.vue?vue&type=script&lang=js&"
export * from "./MailInvoiceSettingCard.vue?vue&type=script&lang=js&"
import style0 from "./MailInvoiceSettingCard.vue?vue&type=style&index=0&id=1c6ce07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ce07a",
  null
  
)

export default component.exports